import { fileManyRelations } from '@jebel/utils';

import { prepareMentionsCreateInput } from 'shared/features/mentions/utils';
import { PostModalCreate, PostModalCreateForm } from 'shared/features/posts';
import { HomeFeedPostCreateInput } from 'shared/graphql';

import { useHomeFeedPostCreate } from '../../hooks';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onCreated?: () => void;
  initialValues?: PostModalCreateForm;
}

export function HomeFeedPostModalCreate({ isOpen, onClose, onCreated, initialValues }: Props) {
  const { create: createPost } = useHomeFeedPostCreate();

  const handleSubmit = async (form: PostModalCreateForm) => {
    const data: HomeFeedPostCreateInput = {
      text: form.text ?? '',
      commentsAllowed: Boolean(form.commentsAllowed),
      isPinned: Boolean(form.isPinned),
    };

    if (form.media) {
      data.media = fileManyRelations(form.media);
    }

    if (form.mentions) {
      const createMentions = form.mentions?.map(prepareMentionsCreateInput);
      data.mentions = { create: createMentions };
    }

    await createPost(data);

    onCreated?.();
    onClose();
  };

  return (
    <PostModalCreate
      initialValues={initialValues}
      onPostCreate={handleSubmit}
      isOpen={isOpen}
      onClose={onClose}
      withPinned={false}
    />
  );
}

export default HomeFeedPostModalCreate;
